import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Grid2 as Grid, Menu, MenuItem, Slide } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';
import { WcedLogo } from '../../shared/components';
import { theme } from '../../app/themes/theme';
import { routeKeys, routeKeyPath } from '../../shared/utils/constants';

const TheHeader = () => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState('Home'); // Track the active button

  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { aiLab, services, contactUs, forParents, forLearners, forTeachers } = routeKeyPath;

  const forTeachersMenu = [
    { title: 'Teacher', path: routeKeys.teachers },
    { title: 'Schools', path: routeKeys.admins },
    { title: 'Parents', path: routeKeys.parents },
    { title: 'Students', path: routeKeys.students },
  ];
  const forStudentsMenu = [
    { title: 'Teacher', path: routeKeys.teachers },
    { title: 'Schools', path: routeKeys.admins },
    { title: 'Parents', path: routeKeys.parents },
    { title: 'Students', path: routeKeys.students },
  ];

  type MenuItem = {
    title: string;
    path: string;
    variant: 'text' | 'contained' | 'outlined';
  };

  const headerMenu: MenuItem[] = [
    { title: 'Home', path: '', variant: 'text' },
    { title: 'Services', path: services, variant: 'text' },
    { title: 'For Teachers', path: forTeachers, variant: 'text' },
    { title: 'For Learners', path: forLearners, variant: 'text' },
    { title: 'For Parents/Guardians', path: forParents, variant: 'text' },
    { title: 'AI Tools', path: aiLab, variant: 'outlined' },
    { title: 'Contact Us', path: routeKeyPath.contactUs, variant: 'contained' },
  ];
  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setOpenMenu(true);
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
    setOpenMenu(false);
  };
  const handleMenuItemClick = (path: string) => {
    navigate(path);
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setShowHeader(false); // Hide header on scroll down
      } else {
        setShowHeader(true); // Show header on scroll up
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);
  useEffect(() => {
    // Check the current path and set the active title
    const currentPath = window.location.pathname;
    const activeItem = headerMenu.find((item) => item.path === currentPath);
    if (activeItem) {
      setActiveIndex(activeItem.title);
    }
  }, [window.location.pathname]); // Trigger whenever the pathname changes

  return (
    <Slide in={showHeader} direction="down">
      <Grid
        container
        spacing={4}
        sx={{
          bgcolor: theme.palette.common.white,
          padding: { xs: '10px', md: '20px' },
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center',
          justifyContent: { md: 'space-between' },
          zIndex: theme.zIndex.appBar, // Ensure the header stays on top
          position: 'sticky', // Sticky to the top
          top: 0,
        }}
      >
        <Grid
          size={{ xs: 12, sm: 4, md: 3 }}
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center', md: 'flex-start' },
          }}
        >
          <WcedLogo />
        </Grid>

        <Grid
          size={{ xs: 12, sm: 8, md: 9 }}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: { xs: 'center', sm: 'space-around' },
          }}
        >
          {headerMenu.map((item, index) => (
            <Button
              key={index}
              variant={item.variant}
              onClick={() => {
                navigate(item.path);
                setActiveIndex(item.title);
                window.scrollTo({ top: 0, behavior: 'smooth' });

              }}
              sx={{
                fontSize: { xs: '0.55rem', sm: '0.65rem', md: '1.2rem' },
                padding: { xs: '6px 10px', sm: '8px 16px', md: '10px 20px' },
                width: { xs: '100%', md: 'auto' },
                marginBottom: { xs: '8px', md: '0' },
                background: activeIndex === item.title || item.path === window.location.pathname ? '#007DBA' : '', // Active button background color
                color: activeIndex === item.title || item.path === window.location.pathname ? '#fff' : 'primary', // Change text color for active button
              }}
            >
              {item.title}
            </Button>
          ))}
        </Grid>
      </Grid>
    </Slide>
  );
};

export default TheHeader;
